const styles = (theme) => ({
  headerSpace: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  headerSection: {
    backgroundColor: theme.palette.background.paper,
  },
  labelSpace: {
    fontWeight: 500,
    letterSpacing: 2,
  },
  amtTxt: {
    textAlign: 'left',
  },
  datePickerWrapper: {
    maxWidth: 170,
    '& > div:first-child > div:first-child': {
      display: 'block',
      '& > div:first-child': {
        display: 'block',
      },
    },
    '& .react-datepicker__header,.react-datepicker__triangle': {
      backgroundColor: theme.palette.overlayScale.white10,
      border: 'none',
    },
    '& .react-datepicker__triangle::after': {
      borderBottomColor: theme.palette.overlayScale.white10,
    },
    '& .react-datepicker__day--selected': {
      backgroundColor: theme.palette.action.selected,
    },
    '& .react-datepicker__day:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '& .react-datepicker__day,.react-datepicker__day-name': {
      color: theme.palette.text.primary,
    },
    '& .react-datepicker__current-month': {
      color: theme.palette.text.secondary,
    },
    '& .react-datepicker__header.react-datepicker__header--custom': {
      color: theme.palette.text.primary,
    },
    '& .react-datepicker__header.react-datepicker__header--custom button': {
      color: theme.palette.text.primary,
    },
    '& .react-datepicker__month-container': {
      backgroundColor: theme.palette.surface.overlay,
    },
    '& .react-datepicker__day--outside-month': {
      color: theme.palette.text.tertiary,
    },
  },
  categories: {
    inputField: {
      '& input': {
        '&::-ms-clear ': {
          display: 'none',
        },
      },
    },
  },
  tags: {
    paddingBottom: 4,
  },
  buttonsSection: {
    background: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.secondary.main}`,
    bottom: 0,
    padding: theme.spacing(2, 0),
    margin: theme.spacing(0, 2.5),
    position: 'sticky',
  },
  formSection: {
    padding: 20,
  },
  fatButton: {
    width: 160,
    height: 36,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.background.paper,
    borderRadius: 20,
    marginRight: 10,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  dialogFatButton: {
    width: 116,
    height: 36,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.background.paper,
    borderRadius: 20,
    marginRight: 10,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  disabledSave: {
    color: `${theme.palette.background.paper} !important`,
    opacity: 0.5,
  },
  cancelButton: {
    marginLeft: 10,
  },
  underlineOverride: {
    '&:before': {
      borderBottom: `1px solid ${theme.palette.background.elevated}`,
    },
    '&&&&:hover:before': {
      borderBottomWidth: '1px',
    },
  },
  inputRight: {
    padding: '0 0 0 12px',
  },
  inputLeft: {
    padding: '0 12px 0 0',
  },
  payeeInput: {
    fontSize: 20,
    fontWeight: 500,
  },
  ellipser: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
  },
  defaultOverride: {
    color: theme.palette.black,
    cursor: 'default',
    borderBottom: `0.5px solid ${theme.palette.background.elevated}`,
  },
  mainSplitTxnsContainer: {
    backgroundColor: theme.palette.background.subtle,
    padding: 10,
  },
  discardText: {
    color: theme.palette.text.secondary,
  },
});

export default styles;
